import { Link } from "react-router-dom";

export const LegalShell = ({ title, updated, children }) => (
  <div className="min-h-screen bg-[#050505] px-4 py-12">
    <div className="max-w-3xl mx-auto">
      <Link to="/" className="font-display text-3xl uppercase tracking-tight text-white hover:opacity-80">EGNCY</Link>
      <h1 className="font-display text-4xl uppercase tracking-tight text-white mt-6 mb-1">{title}</h1>
      <p className="text-xs text-[#737373] mb-8">Last updated: {updated}</p>
      <div className="space-y-6 text-sm text-[#a3a3a3] leading-relaxed [&_h2]:text-white [&_h2]:font-display [&_h2]:text-xl [&_h2]:uppercase [&_h2]:tracking-widest [&_h2]:mt-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_strong]:text-white">
        {children}
      </div>
      <div className="mt-10 pt-6 border-t border-[#262626] text-xs text-[#737373]">
        Questions? Contact <a href="mailto:admin@egncy.net" className="text-white hover:underline">admin@egncy.net</a>
        {" · "}<Link to="/terms" className="hover:text-white underline">Terms</Link>
        {" · "}<Link to="/privacy" className="hover:text-white underline">Privacy</Link>
      </div>
    </div>
  </div>
);

export default function TermsPage() {
  return (
    <LegalShell title="Terms of Service" updated="February 2026">
      <section data-testid="terms-page">
        <h2>1. Who can use EGNCY</h2>
        <p>
          EGNCY is a social platform for footballers, scouts and coaches. You must be at least{" "}
          <strong>16 years old</strong> to create a player account, and at least <strong>18 years old</strong> to
          register as a scout or coach. By creating an account you confirm the date of birth you provide is accurate —
          it cannot be changed later.
        </p>
        <h2>2. Your account</h2>
        <p>
          You are responsible for your account and for keeping your password secure. Accounts for 16–17 year olds
          include additional safety protections, including restrictions on who can message them directly.
        </p>
        <h2>3. Your content</h2>
        <p>
          You keep ownership of the highlights, photos, stats and posts you upload. By posting, you grant EGNCY a
          licence to host, display and distribute that content on the platform so other users (including scouts) can
          see it. Only upload content you have the right to share.
        </p>
        <h2>4. Acceptable use</h2>
        <ul>
          <li>No harassment, bullying, hate speech or threats.</li>
          <li>No impersonation, fake profiles or misleading stats.</li>
          <li>No spam, scams or unsolicited commercial messages.</li>
          <li>No content that sexualises, endangers or exploits minors — zero tolerance.</li>
        </ul>
        <p>
          You can report any post or profile using the flag button, and block any user. We may remove content or
          suspend accounts that break these rules, at our discretion.
        </p>
        <h2>5. Scouts and verification</h2>
        <p>
          Scout and coach accounts may apply for a verified badge. Verification reflects a review of the information
          provided to us; it is not a guarantee. Players should exercise normal caution when communicating about
          trials or offers.
        </p>
        <h2>6. Availability status and profile data</h2>
        <p>
          Optional profile details (region, height, preferred foot, level of play, availability light) exist so scouts
          can discover you. Only share what you're comfortable making visible on your profile.
        </p>
        <h2>7. Disclaimers</h2>
        <p>
          EGNCY is provided "as is". We do not guarantee trials, offers or contact from scouts, and we are not a party
          to any agreement made between users. To the maximum extent permitted by law, we exclude liability for
          indirect or consequential loss.
        </p>
        <h2>8. Changes and termination</h2>
        <p>
          We may update these terms as the platform evolves; material changes will be flagged in-app. You can delete
          your account at any time by contacting us. These terms are governed by the laws of Australia.
        </p>
      </section>
    </LegalShell>
  );
}
